import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import image from "../../src/image/main-logo.png";

const HomeCourses = () => {
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = "https://course-selling-backend-2-rr1n.onrender.com";

  // 🔹 FETCH COURSES (ONLY 3)
  useEffect(() => {
    fetch(`${API}/api/courses`)
      .then((res) => res.json())
      .then((resData) => {
        const courseData = Array.isArray(resData)
          ? resData
          : resData.data || [];

        setCourses(courseData.slice(0, 3));
        setLoading(false);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  }, []);

  // 🔹 VIEW COURSE
  const handleClick = (id) => {
    navigate(`/course/${id}`);
  };

  // 🔹 ENROLL & PAY (RAZORPAY)
  const handleEnrollPay = async (course) => {
    try {
      const res = await fetch(`${API}/api/payment/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount:
            typeof course.price === "number"
              ? course.price
              : parseInt(course.price), // ₹1, ₹999 handle
          courseId: course._id,
        }),
      });

      const order = await res.json();

      const options = {
        key: "rzp_live_RUUK4vJNXWL4ZP", // 🔴 apna Razorpay key_id yaha daalo
        amount: order.amount,
        currency: "INR",
        name: "Medby Academy",
        description: course.title,
        order_id: order.id,

        handler: function (response) {
          console.log("Payment Success:", response);
          alert("Payment Successful 🎉");
          // navigate("/mycourses"); // future use
        },

        prefill: {
          name: "Student",
          email: "student@example.com",
          contact: "9999999999",
        },

        theme: {
          color: "#0ea37a",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment Error:", error);
      alert("Payment failed!");
    }
  };

  return (
    <section className="courses-section">
      <div className="courses-header">
        <h4 className="subtitle">Polish Your Skills, Excel Now</h4>
        <h2 className="title">Our Top-Rated Online Programs</h2>
      </div>

      <div className="course-filters">
        <button>OUR COURSES</button>
      </div>

      {loading ? (
        <p style={{ textAlign: "center" }}>Loading courses...</p>
      ) : (
        <div className="courses-grid-home">
          {courses.map((course) => (
            <div className="course-card" key={course._id}>
              <div className="image-container">
                <img
                  src={
                    course.image ||
                    course.thumbnail ||
                    course.img ||
                    "https://via.placeholder.com/300x200"
                  }
                  alt={course.title}
                />
              </div>

              <h3>{course.title}</h3>

              <p className="Lesson">
                {typeof course.price === "number"
                  ? `₹${course.price}`
                  : course.price}
              </p>

            

             
              <div className="fellowship-buttons-hh">
                <button
                  className="enquire-btn-hh"
                  onClick={() => handleEnrollPay(course)}
                >
                  Enroll & Pay
                </button>

                <button
                  className="view-btn-hh"
                  onClick={() => handleClick(course._id)}
                >
                  View Course
                </button>
              </div>

              <div className="academy-info">
                <img src={image} alt="academy" />
                <p>Medby Academy</p>
              </div>
            </div>
          ))}
        </div>
      )}

      <button
        className="view-more"
        onClick={() => navigate("/Certificate_Courses")}
        style={{
          background: "#0ea37a",
          color: "#fff",
          padding: "12px 20px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "16px",
          marginTop: "20px",
          marginLeft: "35%",
        }}
      >
        View Courses →
      </button>
    </section>
  );
};

export default HomeCourses;
